import { useMutation } from '@tanstack/react-query';
import { api } from '@/api';
import { retryDelay, shouldRetryOnError } from '@/queries/case';

export const useCreateGetStreamToken = () =>
  useMutation({
    mutationFn: () => api.chat.createGetStreamToken(),
    retry: shouldRetryOnError,
    retryDelay,
  });
